<nav class="navbar navbar-expand-md">
  <div class="collapse navbar-collapse" [ngClass]="{ show: toggleMobileMenu }">
    <div class="container">
      <ul *ngIf="rendering.fields" class="navbar-nav">
        <li
          class="nav-item"
          *ngFor="let menuItem of rendering.fields.items"
          [ngClass]="{
            active: menuItem.isActive,
            'open-list': isOpen(menuItem.id)
          }"
          (click)="showSubMenu(menuItem.fields.Link, menuItem.id)"
        >
          <div>
            <a class="btn btn-default"> {{ menuItem.fields.Title.value }}</a>
          </div>
          <div
            class="subnavigation"
            [ngClass]="{ 'd-block': subMenuOpen[menuItem.id] }"
            *ngIf="menuItem.fields.items"
          >
            <div class="container">
              <ul
                class="list-unstyled subnavigation-items-list"
                [ngClass]="{ 'subnavigation-open': subMenuOpen[menuItem.id] }"
              >
                <li
                  class="col-md-3"
                  *ngFor="let subMenuItem of menuItem.fields.items"
                  [ngClass]="{
                    'd-none': !isAccessEnabled(subMenuItem.fields.items)
                  }"
                >
                  <ng-container
                    *ngIf="
                      subMenuItem.fields.items &&
                      subMenuItem.fields.items.length !== 0
                    "
                  >
                    <div class="section-title">
                      {{ subMenuItem.fields.Title.value }}
                    </div>
                    <div
                      class="subnavigation-items"
                      [ngClass]="{
                        'open-submenu': subMenuOpen[menuItem.id]
                      }"
                    >
                      <ul class="list-unstyled">
                        <ng-container
                          *ngFor="let subItem of subMenuItem.fields.items"
                        >
                          <li
                            *ngIf="
                              !subItem?.fields?.Link?.fields?.AccessEnabled ||
                              subItem?.fields?.Link?.fields?.AccessEnabled ===
                                'True'
                            "
                          >
                            <a
                              *ngIf="
                                !subItem?.fields?.QueryString ||
                                subItem?.fields?.QueryString.value === ''
                              "
                              class="btn navigation-links"
                              [routerLink]="subItem?.fields.Link?.url"
                              >{{ subItem?.fields?.Title.value }}</a
                            >
                            <a
                              *ngIf="
                                subItem?.fields?.QueryString &&
                                subItem?.fields?.QueryString.value !== ''
                              "
                              class="btn navigation-links"
                              [routerLink]="subItem?.fields?.Link?.url"
                              [queryParams]="{
                                mode: subItem?.fields?.QueryString.value
                              }"
                              >{{ subItem?.fields?.Title.value }}</a
                            >
                          </li>
                        </ng-container>
                      </ul>
                    </div>
                  </ng-container>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="menu-toggle">
    <a (click)="showMobileMenu()"><i class="icon-bars"></i></a>
  </div>
</nav>
